import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../PRE-LOAD/app-settings';

@Component({
    selector: 'rttd-empty',
    templateUrl: './empty.component.html',
    styleUrls: ['./empty.component.scss']
})
export class EmptyComponent implements OnInit {

    constructor(
        private router: Router,
        private appSettings: AppSettings,
        private activatedRoute: ActivatedRoute,) {
    }

    ngOnInit() {
        if(this.router.url){
            var href = this.router.url;

            if(this.appSettings.eventJourney){
                this.router.navigate(['event'], {skipLocationChange: true})
            } 
            else{
                this.appSettings.eventJourney = false;
 
             var params =   this.activatedRoute.queryParams.subscribe(value => {

                if(value.model == null){
                    this.router.navigate(['select-model'], {skipLocationChange: true});
                }
             });

            }
        }
    }
}
